import { Component, ElementRef, ViewChild } from '@angular/core';
import { HelperServiceService } from '../../../utils/helper-service.service';
import { FormArray, FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { CourseService } from '../../../pages/courses/course.service';
import { environment } from '../../../../environments/environment';
import { Store } from '@ngrx/store';
import { selectCourseId } from '../../../pages/courses/create-courses/store/course.selector';
import { ToasterService } from '../../../providers/toaster/toaster.service';
import { ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { commentTextValidator, testimonialNameValidator, testimonialTextValidator } from '../../../utils/create_course_validators/other/otherValidators';

@Component({
  selector: 'app-others',
  standalone: true,
  imports: [ReactiveFormsModule, CommonModule],
  templateUrl: './others.component.html',
  styleUrl: './others.component.css'
})
export class OthersComponent {
  testimonialProfileUrl: string | null = null
  testimonialProfile: File | null = null
  testimonialForm!: FormGroup;
  commentForm!: FormGroup;

  @ViewChild('commonTestimonialAndCommentModal') commonTestimonialAndCommentModal!: ElementRef<HTMLDialogElement>;

  testimonailList: any = [];
  commentList: any = [];
  filteredTestimonialList: any = [];
  filteredCommentList: any = [];
  facultyList: any = [];
  usersList: any = [];
  courseId: any
  modalSearchText: string = '';
  modalSortBy: string = '';
  othersForm!: FormGroup
  flag: number = 1
  isreqSending: boolean = false;

  isModalAddFormOpen: boolean = false
  modalType: 'testimonial' | 'comment' | null = null
  selectedComments: any[] = [];
  selectedTestimonal: any[] = [];
  pendingDelete: { id: any; type: 'testimonial' | 'comment' } | null = null;

  constructor(private helperService: HelperServiceService, private fb: FormBuilder,
    private couserApiService: CourseService, private store: Store, private toasterService: ToasterService,
    private route: ActivatedRoute) {

    this.othersForm = this.fb.group({
      id: [''],
      course_id: ['', Validators.required],
      faculty_id: ['', Validators.required],
      contributor_id: ['', Validators.required],
      testimonial_id: this.fb.array([], Validators.required),
      commented_id: this.fb.array([], Validators.required)
    });

    this.testimonialForm = this.fb.group({
      user_photo: [null, Validators.required],
      user_name: ['', [Validators.required, testimonialNameValidator()]],
      testimonial: ['', [Validators.required, testimonialTextValidator()]]
    });

    this.commentForm = this.fb.group({
      user_id: ['', Validators.required],
      comment: ['', [Validators.required, commentTextValidator()]]
    });


  }


  ngOnInit() {
    this.store.select(selectCourseId).subscribe((id) => {
      this.courseId = id;
      if (!this.courseId) {
        this.route.paramMap.subscribe(params => {
          this.courseId = params.get('id') || '';
        });

      }
    })
    this.othersForm.patchValue({
      course_id: this.courseId
    })
    this.getData();
  }



  getData() {

    // TODO: get data from API other

    this.couserApiService.getOthersData(this.courseId).subscribe({
      next: (res: any) => {
        console.log('API response:', res);

        // Assign testimonial list
        if (
          res.testimonials?.body?.status === 'success' &&
          res.testimonials?.body?.data
        ) {
          this.testimonailList = res.testimonials.body.data;
          this.filteredTestimonialList = [...this.testimonailList];
        }

        // Assign comment list
        if (
          res.comments?.body?.status === 'success' &&
          res.comments?.body?.data
        ) {
          this.commentList = res.comments.body.data;
          this.filteredCommentList = [...this.commentList];
        }

        // assign faculty list
        if (
          res.faculty?.body?.status === 'success' &&
          res.faculty?.body?.data
        ) {
          this.facultyList = res.faculty.body.data;
        }

        // assign users list
        if (
          res.users?.body?.status === 'success' &&
          res.users?.body?.data
        ) {
          this.usersList = res.users.body.data;
        }

        if (
          res.formdata?.body?.status === 'success' &&
          res.formdata?.body?.data
        ) {
          this.patchValue(res.formdata.body.data);
          this.flag = 0
        }

      },
      error: (err) => {
        console.error('Error fetching data', err);
      }
    });
  }


  patchValue(data: any) {
    if (!data) return;
    // Patch simple fields
    this.othersForm.patchValue({
      id: data.id,
      course_id: data.course_id,
      faculty_id: data.faculty_id,
      contributor_id: data.contributor_id,
    });

    const testimonialValues = this.parseIdArray(data.testimonial_id);
    const commentedValues = this.parseIdArray(data.commented_id);

    const testimonialArray = this.othersForm.get('testimonial_id') as FormArray;
    const commentedArray = this.othersForm.get('commented_id') as FormArray;

    testimonialArray.clear();
    commentedArray.clear();

    testimonialValues.forEach(val => {
      testimonialArray.push(this.fb.control(val));
    });

    commentedValues.forEach(val => {
      commentedArray.push(this.fb.control(val));
    });

    this.selectedComments = commentedValues
      .map((id) => this.commentList.find((item: any) => String(item.id) === String(id)))
      .filter(Boolean)
      .map((item: any) => this.enrichComment(item));

    this.selectedTestimonal = testimonialValues
      .map((id) => this.testimonailList.find((item: any) => String(item.id) === String(id)))
      .filter(Boolean)
      .map((item: any) => this.enrichTestimonial(item));


  }



  setTestimonialProfile(event: any) {
    this.helperService.getImageWithAspectCheck(event, 'square').then(({ image, imageUrl }) => {
      if (image) {
        this.testimonialProfileUrl = imageUrl;
        this.testimonialProfile = image
        this.testimonialForm.patchValue({
          user_photo: image
        });
      }
    })
  }

  saveTestimonial() {
    if (this.testimonialForm.invalid) {
      this.testimonialForm.markAllAsTouched();
      this.toasterService.setToaster('error', 'Invalid Form', 'Please fill all required fields');
      return;
    }

    const formData = new FormData();
    formData.append('course_id', this.courseId);
    formData.append('user_photo', this.testimonialForm.get('user_photo')?.value);
    formData.append('user_name', this.testimonialForm.get('user_name')?.value);
    formData.append('testimonial', this.testimonialForm.get('testimonial')?.value);
    this.isreqSending = true;
    this.couserApiService.addTestimonial(formData).subscribe((res: any) => {
      try {
        if (res.body.status == "success") {
          this.toasterService.setToaster('success', 'Testimonial Added', res.body.message ?? 'Tetstimonial added successfully');
          this.isModalAddFormOpen = false
          // Clear testimonial form after successful add
          this.testimonialForm.reset();
          this.testimonialProfileUrl = null;
          this.testimonialProfile = null;
          this.getData();
        } else {
          if (res.body.message && Array.isArray(res.body.message)) {
            for (const message of res.body.message) {
              this.toasterService.setToaster('error', 'Error', message);
            }
          } else {
            this.toasterService.setToaster('error', 'Error', res.body.message ?? 'An error occurred while adding testimonial');
          }
        }
      } catch (error) {

      }
      this.isreqSending = false;
    });

  }

  saveComment() {
    if (this.commentForm.invalid) {
      this.commentForm.markAllAsTouched();
      this.toasterService.setToaster('error', 'Invalid Form', 'Please fill all required fields');
      return;
    }


    const formData = new FormData();
    formData.append('user_id', this.commentForm.get('user_id')?.value);
    formData.append('comment', this.commentForm.get('comment')?.value);
    this.isreqSending = true;
    this.couserApiService.addComments(formData).subscribe((res: any) => {
      try {
        if (res.body.status == "success") {
          this.toasterService.setToaster('success', 'Comment Added', res.body.message ?? 'Comment added successfully');
          this.isModalAddFormOpen = false
          // Clear comment form after successful add
          this.commentForm.reset();
          this.getData();
        }
      } catch (error) {

      }
      this.isreqSending = false;
    });

  }

  saveForm() {


    if (!this.othersForm.valid) {
      this.othersForm.markAllAsTouched();
      this.toasterService.setToaster('error', 'Invalid Form', 'Please fill all required fields');
      return
    }

    const formValues = this.othersForm.value;
    const formData = new FormData();

    formData.append('course_id', formValues.course_id);
    formData.append('faculty_id', formValues.faculty_id);
    formData.append('contributor_id', formValues.contributor_id);
    formData.append('testimonial_id', JSON.stringify(formValues.testimonial_id || []));
    formData.append('commented_id', JSON.stringify(formValues.commented_id || []));
    this.isreqSending = true;
    this.couserApiService.addOthersData(formData, this.flag, formValues.id ?? null).subscribe((res: any) => {
      try {
        if (res.body.status == "success") {
          this.toasterService.setToaster('success', 'Data Saved', res.body.message ?? 'Data saved successfully');
        }
      } catch (error) {

      }
      this.isreqSending = false;
      this.getData();
    });
  }

  getFormArray(controlName: 'testimonial_id' | 'commented_id'): FormArray {
    return this.othersForm.get(controlName) as FormArray;
  }

  isSelected(controlName: 'testimonial_id' | 'commented_id', id: any): boolean {
    const formArray = this.getFormArray(controlName);
    return formArray.controls.some((control) => String(control.value) === String(id));
  }


  onCheckboxChange(
    event: Event,
    controlName: 'testimonial_id' | 'commented_id',
    i: any // i is an object
  ) {
    const checkbox = event.target as HTMLInputElement;
    const value = checkbox.value;
    const formArray = this.getFormArray(controlName);

    const isChecked = checkbox.checked;

    if (isChecked) {
      const existsInForm = formArray.controls.some((control) => String(control.value) === String(value));
      if (!existsInForm) {
        formArray.push(this.fb.control(i.id));
      }

      // Push the full object if not already included
      if (controlName === 'testimonial_id') {
        const exists = this.selectedTestimonal.some(obj => String(obj.id) === String(value));
        if (!exists) this.selectedTestimonal.push(this.enrichTestimonial(i));
      } else if (controlName === 'commented_id') {
        const exists = this.selectedComments.some(obj => String(obj.id) === String(value));
        if (!exists) this.selectedComments.push(this.enrichComment(i));
      }

    } else {
      const index = formArray.controls.findIndex((control) => String(control.value) === String(value));
      if (index > -1) {
        formArray.removeAt(index);
      }

      // Remove full object from array by matching `id`
      if (controlName === 'testimonial_id') {
        this.selectedTestimonal = this.selectedTestimonal.filter(obj => String(obj.id) !== String(value));
      } else if (controlName === 'commented_id') {
        this.selectedComments = this.selectedComments.filter(obj => String(obj.id) !== String(value));
      }
    }

    console.log('Selected Comments:', this.selectedComments);
    console.log('Selected Testimonials:', this.selectedTestimonal);
  }

  removetestimonalAndComment(id: any, controlName: 'testimonial_id' | 'commented_id') {
    const formArray = this.getFormArray(controlName);
    if (controlName == 'testimonial_id') {
      this.selectedTestimonal = this.selectedTestimonal.filter(obj => String(obj.id) !== String(id));
    } else if (controlName == 'commented_id') {
      this.selectedComments = this.selectedComments.filter(obj => String(obj.id) !== String(id));
    }

    const index = formArray.controls.findIndex((control) => String(control.value) === String(id));
    if (index > -1) {
      formArray.removeAt(index);
    }
  }

  deleteTestimonial(id: any, event?: Event) {
    event?.preventDefault();
    event?.stopPropagation();
    this.openDeleteConfirm(id, 'testimonial');
  }

  deleteComment(id: any, event?: Event) {
    event?.preventDefault();
    event?.stopPropagation();
    this.openDeleteConfirm(id, 'comment');
  }

  openDeleteConfirm(id: any, type: 'testimonial' | 'comment') {
    this.pendingDelete = { id, type };
  }

  closeDeleteConfirm() {
    this.pendingDelete = null;
  }

  confirmDelete() {
    if (!this.pendingDelete || this.isreqSending) return;

    const { id, type } = this.pendingDelete;
    const deleteReq = type === 'testimonial'
      ? this.couserApiService.deleteTestimonial(id)
      : this.couserApiService.deleteComment(id);

    this.isreqSending = true;
    deleteReq.subscribe({
      next: (res: any) => {
        if (res?.body?.status === 'success') {
          this.removeDeletedRecord(id, type);
          const title = type === 'testimonial' ? 'Testimonial Deleted' : 'Comment Deleted';
          const fallbackMsg = type === 'testimonial' ? 'Testimonial deleted successfully' : 'Comment deleted successfully';
          this.toasterService.setToaster('success', title, res.body.message ?? fallbackMsg);
          this.closeDeleteConfirm();
          this.isreqSending = false;
        } else {
          const fallbackErr = type === 'testimonial' ? 'Failed to delete testimonial' : 'Failed to delete comment';
          this.toasterService.setToaster('error', 'Delete Failed', res?.body?.message ?? fallbackErr);
        }
      },
      error: (error) => {
        const fallbackErr = type === 'testimonial' ? 'Failed to delete testimonial' : 'Failed to delete comment';
        this.toasterService.setToaster('error', 'Delete Failed', error?.error?.message ?? fallbackErr);
      },
      complete: () => {
        this.isreqSending = false;
      }
    });
  }

  private removeDeletedRecord(id: any, type: 'testimonial' | 'comment') {
    const controlName = type === 'testimonial' ? 'testimonial_id' : 'commented_id';
    const formArray = this.getFormArray(controlName);
    const removeIndex = formArray.controls.findIndex(control => String(control.value) === String(id));
    if (removeIndex > -1) {
      formArray.removeAt(removeIndex);
    }

    if (type === 'testimonial') {
      this.testimonailList = this.testimonailList.filter((item: any) => String(item.id) !== String(id));
      this.filteredTestimonialList = this.filteredTestimonialList.filter((item: any) => String(item.id) !== String(id));
      this.selectedTestimonal = this.selectedTestimonal.filter((item: any) => String(item.id) !== String(id));
    } else {
      this.commentList = this.commentList.filter((item: any) => String(item.id) !== String(id));
      this.filteredCommentList = this.filteredCommentList.filter((item: any) => String(item.id) !== String(id));
      this.selectedComments = this.selectedComments.filter((item: any) => String(item.id) !== String(id));
    }
  }


  showTestimonalAndCommentModal(type: 'testimonial' | 'comment') {
    this.modalSearchText = '';
    this.modalSortBy = '';
    this.resetFilteredModalData();
    this.commonTestimonialAndCommentModal.nativeElement.showModal();
    this.modalType = type;
  }

  applyModalSearch(searchTerm: string) {
    const term = String(searchTerm || '').trim().toLowerCase();

    if (!term) {
      this.resetFilteredModalData();
    } else if (this.modalType === 'testimonial') {
      this.filteredTestimonialList = this.testimonailList.filter((item: any) => {
        const name = this.getTestimonialUserName(item).toLowerCase();
        const testimonialText = String(item.testimonial || '').toLowerCase();
        return name.includes(term) || testimonialText.includes(term);
      });
    } else if (this.modalType === 'comment') {
      this.filteredCommentList = this.commentList.filter((item: any) => {
        const name = this.getCommentUserName(item).toLowerCase();
        const commentText = String(item.comments || item.comment || '').toLowerCase();
        return name.includes(term) || commentText.includes(term);
      });
    }

    if (this.modalSortBy) {
      this.sortFilteredModalData(this.modalSortBy);
    }
  }

  applyModalSort(sortBy: string) {
    this.modalSortBy = sortBy || '';
    if (!sortBy) {
      return;
    }
    this.sortFilteredModalData(sortBy);
  }

  clearModalFilters(sortSelect?: HTMLSelectElement, searchInput?: HTMLInputElement) {
    this.modalSearchText = '';
    this.modalSortBy = '';
    this.resetFilteredModalData();

    if (sortSelect) {
      sortSelect.value = '';
    }
    if (searchInput) {
      searchInput.value = '';
    }
  }

  private sortFilteredModalData(sortBy: string) {
    if (this.modalType === 'testimonial') {
      this.filteredTestimonialList = [...this.filteredTestimonialList].sort((a: any, b: any) => {
        if (sortBy === 'name-asc') {
          return this.getTestimonialUserName(a).localeCompare(this.getTestimonialUserName(b));
        }
        if (sortBy === 'name-desc') {
          return this.getTestimonialUserName(b).localeCompare(this.getTestimonialUserName(a));
        }
        const aDate = this.parseItemDate(a);
        const bDate = this.parseItemDate(b);
        return sortBy === 'date-asc' ? aDate - bDate : bDate - aDate;
      });
    } else if (this.modalType === 'comment') {
      this.filteredCommentList = [...this.filteredCommentList].sort((a: any, b: any) => {
        if (sortBy === 'name-asc') {
          return this.getCommentUserName(a).localeCompare(this.getCommentUserName(b));
        }
        if (sortBy === 'name-desc') {
          return this.getCommentUserName(b).localeCompare(this.getCommentUserName(a));
        }
        const aDate = this.parseItemDate(a);
        const bDate = this.parseItemDate(b);
        return sortBy === 'date-asc' ? aDate - bDate : bDate - aDate;
      });
    }
  }

  private parseItemDate(item: any): number {
    const dateValue = item?.created_at || item?.updated_at || item?.date || item?.createdAt || item?.updatedAt;
    const parsed = Date.parse(String(dateValue || ''));
    return Number.isNaN(parsed) ? 0 : parsed;
  }

  private resetFilteredModalData() {
    this.filteredTestimonialList = [...this.testimonailList];
    this.filteredCommentList = [...this.commentList];
  }


  restForm() {
    this.testimonialForm.reset();
    this.commentForm.reset();
    this.testimonialProfileUrl = null
    this.testimonialProfile = null;
    this.isModalAddFormOpen = false
    this.commonTestimonialAndCommentModal.nativeElement.close();
    this.closeDeleteConfirm();
  }

  getTestimonialUserName(item: any): string {
    return item?.resolved_user_name || item?.user_name || item?.user?.name || this.getUserNameById(item?.user_id) || 'Unknown User';
  }

  baseUrl = environment.apiUrl.replace('/api/v1/', '');

  getTestimonialUserImage(item: any): string {
  const image =
    item?.user_photo ||
    item?.resolved_user_image ||
    item?.user_image ||
    item?.user?.photo ||
    this.getUserImageById(item?.user_id);
    // console.log('Resolved image for testimonial:', `https://tfuat.pspldemo.in/storage/${image}`);
  return image
    ? `${image}`
    : 'assets/dummy_thumbnail.png';
}

  getCommentUserName(item: any): string {
    return item?.resolved_user_name || item?.user?.name || item?.user_name || this.getUserNameById(item?.user_id) || 'Unknown User';
  }

  getCommentUserImage(item: any): string {
    return item?.resolved_user_image || item?.user_image || item?.user?.photo || this.getUserImageById(item?.user_id) || 'assets/dummy_thumbnail.png';
  }

  private parseIdArray(value: any): string[] {
    if (Array.isArray(value)) {
      return value.map((v) => String(v));
    }

    if (typeof value === 'string') {
      const trimmed = value.trim();
      if (!trimmed) return [];

      try {
        const parsed = JSON.parse(trimmed);
        if (Array.isArray(parsed)) {
          return parsed.map((v) => String(v));
        }
      } catch {
        // Fallback for malformed values like "[66]" with extra chars
      }

      return trimmed
        .replace(/^\[/, '')
        .replace(/\]$/, '')
        .split(',')
        .map((v) => v.replace(/"/g, '').trim())
        .filter(Boolean);
    }

    return [];
  }

  private enrichTestimonial(item: any): any {
    return {
      ...item,
      resolved_user_name: this.getTestimonialUserName(item),
      resolved_user_image: this.getTestimonialUserImage(item)
    };
  }

  private enrichComment(item: any): any {
    return {
      ...item,
      resolved_user_name: this.getCommentUserName(item),
      resolved_user_image: this.getCommentUserImage(item)
    };
  }

  private getUserNameById(userId: any): string {
    if (!userId) return '';
    const faculty = this.facultyList.find((f: any) => String(f.id) === String(userId));
    if (faculty?.name) return faculty.name;

    const user = this.usersList.find((u: any) => String(u.id) === String(userId));
    return user?.name || '';
  }

  private getUserImageById(userId: any): string {
    if (!userId) return '';
    const faculty = this.facultyList.find((f: any) => String(f.id) === String(userId));
    if (faculty?.user_image || faculty?.photo || faculty?.profile_photo) {
      return faculty.user_image || faculty.photo || faculty.profile_photo;
    }

    const user = this.usersList.find((u: any) => String(u.id) === String(userId));
    return user?.user_image || user?.photo || user?.profile_photo || user?.avatar || '';
  }

}
